import loadable from '@loadable/component';
import Loading from '../../../shared/Loading';

export const LoadableApp = loadable(() => import('../../../components/App'), {
  fallback: Loading,
});
export const LoadableSuggestionConfirmation = loadable(
  () => import('../../../components/SuggestionConfirmation'),
  {
    fallback: Loading,
  },
);
export const LoadableCommentActivityPage = loadable(
  () => import('../../../views/CommentActivityPage'),
  {
    fallback: Loading,
  },
);
export const LoadableUserProfile = loadable(
  () => import('../../../views/UserProfilePage'),
  {
    ssr: false,
    fallback: Loading,
  },
);
export const LoadableAskQuestionPage = loadable(
  () => import('../../../views/AskQuestionPage'),
  {
    fallback: Loading,
  },
);
export const LoadablePage = loadable(() => import('../../../components/Page'), {
  fallback: Loading,
});
export const LoadableLayout = loadable(
  () => import('../../../components/Layout'),
  {
    fallback: Loading,
  },
);
export const LoadableHealthcheck = loadable(
  () => import('../../../components/Healthcheck/Healthcheck.react'),
  {
    fallback: Loading,
  },
);
export const LoadableLogin = loadable(
  () => import('../../../base-styles/Login'),
  {
    fallback: Loading,
  },
);
export const LoadableLoginCallback = loadable(
  () => import('../../../components/LoginCallback'),
  {
    fallback: Loading,
  },
);
export const LoadableCognitoLoginCallback = loadable(
  () => import('../../../views/Cognito/LoginCallback'),
  {
    fallback: Loading,
  },
);
export const LoadableLogout = loadable(
  () => import('../../../views/Cognito/Logout'),
  {
    fallback: Loading,
  },
);
export const LoadableStripeConnectLanding = loadable(
  () => import('../../../components/Stripe/Connect/Landing'),
  {
    fallback: Loading,
  },
);
export const LoadableStripeConnectSuccess = loadable(
  () => import('../../../components/Stripe/Connect/Success'),
  {
    fallback: Loading,
  },
);
export const LoadableSaveEventPage = loadable(
  () => import('../../../containers/SaveEventPage'),
  {
    fallback: Loading,
  },
);
export const LoadableUnsaveEventPage = loadable(
  () => import('../../../containers/UnsaveEventPage'),
  {
    fallback: Loading,
  },
);
export const LoadableLikeActivityPage = loadable(
  () => import('../../../views/LikeActivityPage'),
  {
    fallback: Loading,
  },
);
export const LoadableUnlikeActivityPage = loadable(
  () => import('../../../views/UnlikeActivityPage'),
  {
    fallback: Loading,
  },
);

export const LoadableEventReviewPage = loadable(
  () => import('../../../views/EventReviewPage'),
  {
    fallback: Loading,
  },
);
export const LoadableEventTicketsPage = loadable(
  () => import('../../../components/EventTicketsPage'),
  {
    fallback: Loading,
  },
);
export const LoadableEventReviewPageSuccess = loadable(
  () => import('../../../views/EventReviewPage/EventReviewSuccess'),
  {
    fallback: Loading,
  },
);
export const LoadableEventReviewPageFormWrapper = loadable(
  () => import('../../../views/EventReviewPage/EventReviewFormWrapper'),
  {
    fallback: Loading,
  },
);
export const LoadablePrivateProfileSettingsPage = loadable(
  () => import('../../../views/ProfilePage/Settings'),
  {
    fallback: Loading,
  },
);
export const LoadablePrivateEmailPrefsPage = loadable(
  () => import('../../../views/ProfilePage/EmailPrefs'),
  {
    fallback: Loading,
  },
);
export const LoadablePrivateMyEventsPage = loadable(
  () => import('../../../views/MyEventsPage'),
  {
    fallback: Loading,
  },
);
export const LoadablePrivateMyEventPage = loadable(
  () => import('../../../views/MyEventPage'),
  {
    fallback: Loading,
  },
);
export const LoadableAboutUsPage = loadable(
  () => import('../../../components/AboutUsPage'),
  {
    fallback: Loading,
  },
);
export const LoadableBrandPartnershipsPage = loadable(
  () => import('../../../views/BrandPartnershipsPage'),
  {
    fallback: Loading,
  },
);
export const LoadableBookingFormPage = loadable(
  () => import('../../../views/BookingFormPage'),
  {
    fallback: Loading,
  },
);
export const LoadablePayments = loadable(
  () => import('../../../components/Legal/components/Payments'),
  {
    fallback: Loading,
  },
);
export const LoadablePrivacy = loadable(
  () => import('../../../components/Legal/components/Privacy'),
  {
    fallback: Loading,
  },
);
export const LoadableRefunds = loadable(
  () => import('../../../components/Legal/components/Refunds'),
  {
    fallback: Loading,
  },
);
export const LoadableTerms = loadable(
  () => import('../../../components/Legal/components/Terms'),
  {
    fallback: Loading,
  },
);
export const LoadableNotFound = loadable(
  () => import('../../../components/NotFound'),
  {
    fallback: Loading,
  },
);
export const LoadableOnboardingPage = loadable(
  () => import('../../../views/OnboardingPage'),
  {
    fallback: Loading,
  },
);
export const LoadableLeaderboardPage = loadable(
  () => import('../../../views/LeaderboardPage'),
  {
    fallback: Loading,
  },
);
export const LoadableCookiePolicy = loadable(
  () => import('../../../shared/CookiePolicy/component'),
  {
    fallback: Loading,
  },
);
export const LoadableJoinGroupMutationPage = loadable(
  () => import('../../../views/JoinGroupMutationPage'),
  {
    fallback: Loading,
  },
);
export const LoadableJoinGroupPage = loadable(
  () => import('../../../views/JoinGroupPage'),
  {
    ssr: false,
    fallback: Loading,
  },
);
export const LoadableGroupPage = loadable(
  () => import('../../../views/GroupPage'),
  {
    fallback: Loading,
  },
);
export const LoadableLabsPage = loadable(
  () => import('../../../views/LabsPage'),
  {
    fallback: Loading,
  },
);
export const LoadableSocialPage = loadable(
  () => import('../../../views/SocialPage'),
  {
    fallback: Loading,
  },
);
export const LoadableSquadsAcceptInvitePage = loadable(
  () => import('../../../views/SquadsAcceptInvitePage'),
  {
    fallback: Loading,
  },
);
export const LoadableCategoryPage = loadable(
  () => import('../../../views/CategoryPage'),
  {
    fallback: Loading,
  },
);
export const LoadableHomePageRouter = loadable(
  () => import('../../../views/HomepageRouter'),
  {
    fallback: Loading,
  },
);
export const LoadableChallengeAwardsPage = loadable(
  () => import('../../../views/ChallengeAwardsPage'),
  {
    fallback: Loading,
  },
);
export const LoadableCharityEntryPage = loadable(
  () => import('../../../containers/CharityEntryPage'),
  {
    fallback: Loading,
  },
);
export const LoadableEventDetailPage = loadable(
  () => import('../../../containers/EventDetailPage'),
  {
    fallback: Loading,
  },
);
export const LoadableSubmissionRouter = loadable(
  () => import('../../../views/VirtualEvent/layout/SubmissionRouter'),
  {
    fallback: Loading,
  },
);
export const LoadableBibCollectionPage = loadable(
  () => import('../../../views/VirtualEvent/layout/BibCollectionPage'),
  {
    fallback: Loading,
  },
);

export const LoadableSaveExternalBookingPage = loadable(
  () => import('../../../containers/SaveExternalBookingPage'),
  {
    fallback: Loading,
  },
);

export const LoadableUnsaveExternalBookingPage = loadable(
  () => import('../../../containers/UnsaveExternalBookingPage'),
  {
    fallback: Loading,
  },
);

export const LoadableUnsubscribeEmailPage = loadable(
  () => import('../../../containers/UnsubscribeEmailPage'),
  {
    fallback: Loading,
  },
);

export const LoadableOrganiserClaimPage = loadable(
  () => import('../../../components/OrganiserClaim'),
  {
    fallback: Loading,
  },
);

export const LoadableOrganiserClaimByTokenPage = loadable(
  () => import('../../../views/OrganiserClaimByTokenPage'),
  {
    fallback: Loading,
  },
);

export const LoadableDynamicBookingForm = loadable(
  () => import('../../../views/DynamicBookingForm'),
  {
    fallback: Loading,
  },
);

export const LoadableAddEventPage = loadable(
  () => import('../../../views/AddEventPage'),
  {
    fallback: Loading,
  },
);

export const LoadableSavedEventsPage = loadable(
  () => import('../../../views/SavedEventsPage'),
  {
    ssr: false,
    fallback: Loading,
  },
);

export const LoadableCommunityPage = loadable(
  () => import('../../../views/CommunityPage'),
  {
    ssr: false,
    fallback: Loading,
  },
);

export const LoadableNotificationsPage = loadable(
  () => import('../../../views/NotificationsPage'),
  {
    fallback: Loading,
  },
);

export const LoadableOrganiserDashboardPage = loadable(
  () => import('../../../views/OrganiserDashboard'),
  {
    ssr: false,
    fallback: Loading,
  },
);

export const LoadableLDTDashboardPage = loadable(
  () => import('../../../views/LDTDashboard'),
  {
    ssr: false,
    fallback: Loading,
  },
);
